import { ChartModel } from './chart.model';
/**
 * Line chart model definition
 */
export class LineChartModel extends ChartModel {
/**
 * Set the minimum value of the y axis to the minimum value in the data, instead of 0. Default: false.
 */
autoScale?: boolean;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super();
    Object.assign(this, values);
  }
}

function LineChartModel_tsickle_Closure_declarations() {
/**
 * Set the minimum value of the y axis to the minimum value in the data, instead of 0. Default: false.
 * @type {?}
 */
LineChartModel.prototype.autoScale;
}

